<template>
  <div class="promocodes-page">
    <UiIntroSearch
      class="promocodes-page-intro"
      header="Промокоды"
      text="Используйте промокоды и экономьте при заказе в 4530 магазинах России и 26 странах"
      placeholder="Введите название магазина"
      image="/static/images/promocodes.svg"
      empty-start="Магазинов"
      slug-param="coupons_slug"
      :search-start="2"
      :data="searchShops"
      :loading="loading"
      @change="queryChange"
    />
    <DelayHydration>
      <constructor-components
        :is-home-page="false"
        :sections="mainConstructor.items"
      />
    </DelayHydration>
  </div>
</template>

<script setup lang="ts">
import getConstructorData from '~/components/constructor-components/getConstructorData';
import { API } from '~/api/api';
import type { resultIntroSearchItem } from '~/interfaces/app';
import { base64ToObj, objToBase64 } from '~/utils/base64';
const searchShops = ref<resultIntroSearchItem[]>([]);
const loading = ref(false);
const mainConstructor = ref<any>([]);
const searchThrottle = ref<ReturnType<typeof setTimeout>>();

const asyncPromocodeData = await useAsyncData(
  'asyncPromocodeData',
  async () => {
    const data = await getConstructorData('site/promo-dashboard');
    return objToBase64({ data });
  }
);

if (asyncPromocodeData?.data?.value) {
  const data = base64ToObj(asyncPromocodeData.data.value).data;
  const itemsData = data?.items || [];
  mainConstructor.value = { items: itemsData };
}

const queryChange = (query: string) => {
  searchShops.value = [];
  loading.value = true;
  clearTimeout(searchThrottle.value as ReturnType<typeof setTimeout>);
  searchThrottle.value = setTimeout(async () => {
    if (query && query.length > 2) {
      try {
        const res = await API.get('/coupons/shops/search', {
          params: { query },
        });
        searchShops.value = res.data as resultIntroSearchItem[];
      } catch {
        searchShops.value = [];
      } finally {
        loading.value = false;
      }
    }
  }, 400);
};
</script>
